module.exports = __webpack_public_path__ + "static/img/4-open2.56499231.png";